<template>
  <div class="mx-auto article-preview w-100 h-100">
    <mobile-box
      :content="previewContent"
      :cover="coverUrl"
      class="mobile-box"
    ></mobile-box>
  </div>
</template>

<script>
import { getCookie, Auth } from "@/lib/cookie";
import MobileBox from "@/components/admin/view/article/create/MobileBox";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    MobileBox
  },
  data() {
    return {
      title: "",
      contentHtml: "",
      coverUrl: "",
      articleId: this.$route.params.articleId,
    };
  },
  computed: {
    previewContent() {
      return {
        title: this.title,
        body: this.contentHtml
      };
    },
  },
  async created() {
    await this.checkAuthen();
    await this.getArticle(this.articleId);
  },
  methods: {
    checkAuthen() {
      const token = getCookie(Auth.AccessToken);

      if (token === null) {
        this.$router.push({
          path: "/admins/logins",
          query: { redirect: `/admins/articles/preview/${this.articleId}` }
        });
      }
    },
    async getArticle(articleId) {
      try {
        const res = await baanRueJaiClient.admin.articles.get(articleId);
        const contentJson = JSON.parse(res.data.content);

        this.title = res.data.title;
        this.contentHtml = this.parseContent(contentJson);

        await this.downloadImage(res.data.cover);
      } catch (e) {
        const errorMessage = e.response
          ? e.response.data.message || "ไม่สามารถดึงข้อมูลได้"
          : "เกิดข้อผิดพลาดในการเชื่อมต่อกับเซิร์ฟเวอร์";

        this.$message.error(errorMessage);
      }
    },
    async downloadImage(imageKey) {
      const res = await baanRueJaiClient.downloadImage(imageKey);

      this.coverUrl = res.data.url;
    },
    parseContent(contentJson) {
      let contentHtml = "";
      let lastText = "";

      contentJson.forEach(e => {
        let text = e.insert;
        const attributes = e.attributes || {};

        if (attributes.bold) text = `<b>${text}</b>`;
        if (attributes.underline) text = `<u>${text}</u>`;
        if (attributes.link)
          text = `<a href=${attributes.header} target="_blank">${text}</a>`;
        if (attributes.blockquote)
          lastText = `<blockquote>${lastText}</blockquote>`;

        while (text.includes("\n")) {
          const idx = text.indexOf("\n");
          const cutText = text.substr(0, idx);
          lastText += cutText;

          if (attributes.header)
            lastText = `<h${attributes.header}>${lastText}</h${attributes.header}>`;

          contentHtml += lastText;
          contentHtml += "\n";
          lastText = "";
          text = text.replace(`${cutText  }\n`, "");
        }
        lastText += text;
      });

      return contentHtml;
    }
  }
};
</script>

<style scoped>
.article-preview {
  overflow-y: scroll;
  display: flex;
  justify-content: center;

  .mobile-box {
    background-color: white;
    box-shadow: 0 0px 3px 0 rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    max-width: 50vw;
    height: max-content;
    margin: 24px 0;
  }

  @media screen and (max-width: 768px) {
    .mobile-box {
      max-width: 100vw;
      box-shadow: 0;
      border-radius: 0;
      margin: 0;
    }
    .cover {
      border-radius: 0 !important;
    }
  }

  @media screen and (min-width: 1280px) {
    .mobile-box {
      max-width: 640px;
    }
  }
}
</style>
